module.exports = __webpack_public_path__ + "static/media/upload.02c96167.svg";